import {gql} from "@apollo/client"

import {TenantUser, TenantUserDocumentAccessType} from "../../_generated/typed-document-nodes"

export const tenantUserList = gql(`query tenantUserList ($params: TenantUserQueryParams, $after: String) {
    tenantUserList (params: $params, after: $after  ) {
        edges {
            creationDate
            creationUserId
            creationUserLabel
            lastModificationDate
            lastModificationUserId
            lastModificationUserLabel
            id
            civility
            firstName
            lastName
            email
            userId
            phone
            culture
            timeZone
            isEnabled
            tenantId
            documentAccessType
            weeklyReport
            services {
                id
                name
            }
        }
        pageInfo {
            hasNextPage
            endCursor
        }
    }
}`)

export const addTenantUser = gql(`mutation addTenantUser ($item: TenantUserInput!, $tenantId: String) {
    addTenantUser (item: $item, tenantId: $tenantId) {
        creationDate
        creationUserId
        creationUserLabel
        lastModificationDate
        lastModificationUserId
        lastModificationUserLabel
        id
        civility
        firstName
        lastName
        email
        userId
        phone
        culture
        timeZone
        isEnabled
        tenantId
        documentAccessType
        weeklyReport
        services {
            id
            name
        }
    }
}`)

export const editTenantUser = gql(`mutation editTenantUser ($id: String!, $item: TenantUserInput!) {
    editTenantUser (id: $id, item: $item) {
        creationDate
        creationUserId
        creationUserLabel
        lastModificationDate
        lastModificationUserId
        lastModificationUserLabel
        id
        civility
        firstName
        lastName
        email
        userId
        phone
        culture
        timeZone
        isEnabled
        tenantId
        documentAccessType
        weeklyReport
        services {
            id
            name
        }
    }
}`)

export const tenantUserItems = gql(`query tenantUserItems ($idList: [String!]!) {
    tenantUserItems (idList: $idList) {
        creationDate
        creationUserId
        creationUserLabel
        lastModificationDate
        lastModificationUserId
        lastModificationUserLabel
        id
        civility
        firstName
        lastName
        email
        userId
        phone
        culture
        timeZone
        isEnabled
        tenantId
        documentAccessType
        weeklyReport
        services {
            id
            name
        }
    }
}`)

export const resendInviteTenantUser = gql(`mutation resendInviteTenantUser ($id: String!) {
    resendInviteTenantUser (id: $id)
}`)

export const EditTenantUserRight =
    gql(`mutation editTenantUserRight ($tenantUserId: String!, $item: [TenantRightValueInput!], $tenantId: String) {
    editTenantUserRight (tenantUserId: $tenantUserId, item: $item, tenantId: $tenantId) {
        right
        value
    }
}`)
export const editTenantUserRight =
    gql(`mutation editTenantUserRight ($tenantUserId: String!, $item: [TenantRightValueInput!]) {
    editTenantUserRight (tenantUserId: $tenantUserId, item: $item) {
        right
        value
    }
}`)

export const tenantUserRightList =
    gql(`query tenantUserRightList ($tenantUserId: String!, $params: RightValueQueryParams, $after: String) {
    tenantUserRightList (tenantUserId: $tenantUserId, params: $params, after: $after) {
        edges {
            right
            value
        }
        pageInfo {
            hasNextPage
            endCursor
        }
    }
}`)

export const initialTenantUser: TenantUser = {
    __typename: "TenantUser",
    civility: "", // Valeur initiale vide
    creationDate: null, // Peut être null ou undefined
    creationUserId: null, // Peut être null ou undefined
    creationUserLabel: null, // Peut être null ou undefined
    culture: "", // Valeur initiale vide
    documentAccessType: TenantUserDocumentAccessType.Full, // Exemple de type de document, modifiez-le en fonction de vos besoins
    email: "", // Valeur initiale vide
    firstName: "", // Valeur initiale vide
    id: "", // Valeur initiale vide
    isEnabled: false, // Par défaut à false
    lastConnectionDate: null, // Peut être null ou undefined
    lastModificationDate: null, // Peut être null ou undefined
    lastModificationUserId: null, // Peut être null ou undefined
    lastModificationUserLabel: null, // Peut être null ou undefined
    lastName: "", // Valeur initiale vide
    phone: "", // Valeur initiale vide
    services: [], // Liste initialement vide
    tenantId: "", // Valeur initiale vide
    timeZone: "UTC", // Valeur par défaut
    userId: "", // Valeur initiale vide
    weeklyReport: false // Par défaut à false
}
